// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"30":"bf1e298ad82046eeb7c4","489":"b90d9f86a45579152f6d"}[chunkId] + ".js";
};